export default __webpack_public_path__ + "static/nasa-earth-55814f848f7d93172805ea59b759ec92.jpg";